import React, { Fragment } from 'react';
import { Container } from 'react-bootstrap';
import HeaderLogged from '../../../../components/header_logged'
import Footer from '../../../../components/footer'
import Head from '../../../../components/head';
import FormCad from '../../../../components/auth/lrf/form_cad'


function CadastrarLrfScreen() {

    return (
        <Fragment>
            <Head titulo="Cadastrar LRF" />
            <HeaderLogged />
            <Container>
               <FormCad />
            </Container>
            <Footer />
        </Fragment>
    );
}

export default CadastrarLrfScreen;